
import { marked } from 'marked';
import {Component, Prop, Vue} from 'vue-property-decorator';

const NO_HELP = 'Sorry, no help text given yet.';

@Component
export default class HelpComponent extends Vue {
  @Prop()
  content!: string
  show: boolean = false

  get helpTextHtml() {
    return marked.parse(this.content || NO_HELP)
  }

  close() {
    this.show = false
  }
}
